<template>
  <header class="gss-header w-100">
    <b-navbar variant="info" class="pl-0 pr-0">
      <a class="navbar-brand pointer" @click="goHome()" href="#"
        ><img alt="Logo Generali" src="../assets/images/logo-generali.svg"
      /></a>
      <span class="title pointer" @click="goHome()">MioS</span>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right menu -->
        <b-navbar-nav
          class="stepper-bar ml-auto"
          :class="{ 'no-stepper': hideSteps }"
        >
          <template v-if="!hideSteps">
            <app-stepper
              v-for="(step, index) in stepList"
              :key="index"
              :text="step.title"
              :destination="step.destination"
              :disabled="stepActive < index + 2"
              :is-active="stepActive == index + 1 ? true : false"
            ></app-stepper>
          </template>
          <b-nav-item-dropdown
            class="menu-props"
            no-caret
            content=""
            text="☰"
            right
            v-if="showMenu"
          >
            <!-- Using 'button-content' slot -->
            <template slot="button-content" no-caret>
              <img src="../assets/images/more-vert.svg" />
            </template>
            <b-dropdown-item @click="showModal()" class="menu-item">
              <span class="menu-icon archive-icon"></span>
              Archivio
            </b-dropdown-item>
            <b-dropdown-item href="/logout" class="menu-item">
              <span class="menu-icon logout-icon"></span>
              Logout
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-modal
      v-model="modal"
      adaptive="true"
      title="GSS"
      dialog-class="modal-full"
      hide-footer
    >
      <template v-slot:modal-header>
        &nbsp;
        <b-button
          variant="link modal-close"
          size="sm"
          class="float-right"
          @click="modal = false"
        >
          <img src="../assets/images/close.svg" alt="Chiudi" />
        </b-button>
      </template>
      <b-container style="height: 80vh">
        <archive></archive>
      </b-container>
    </b-modal>
  </header>
</template>

<script>
import router from "../router";
import Stepper from "./Stepper";
import { StepsData } from "../data/steps.data";
import Archive from "../views/modals/Archive";

export default {
  name: "AppHeader.vue",
  components: {
    Archive,
    "app-stepper": Stepper
  },
  props: {
    showMenu: {
      type: Boolean,
      default: false
    },
    stepActive: Number,
    hideSteps: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      stepList: [],
      modal: false
    };
  },
  created() {
    this.stepList = StepsData;
  },
  methods: {
    showModal() {
      this.modal = true;
    },
    goHome() {
      router.push("/");
    }
  }
};
</script>

<style lang="scss"></style>
